import { CoreBadgeType } from './types';
import { DeviationResourceType } from '../types/deviation';
import { ResourceType } from '../types/resource';
// Order of badges by price, only backend knows exact prices,
// frontend only needs to know the relative order.
var coreBadgeSortOrder = [
    CoreBadgeType.GLASS,
    CoreBadgeType.EMERALD,
    CoreBadgeType.DIAMOND,
];
// Comparison function that sorts badges in the order specified above
export function sortPapiBadge(a, b) {
    var idxA = coreBadgeSortOrder.findIndex(function (badge) { return badge === a.name; });
    var idxB = coreBadgeSortOrder.findIndex(function (badge) { return badge === b.name; });
    return idxA - idxB;
}
// Same as the sortPapiBadge, but the price is available
export function sortAwardableBadge(a, b) {
    return a.price - b.price;
}
export function getRecipientSectionName(typeId) {
    var recipientType;
    if (DeviationResourceType[typeId]) {
        recipientType = 'deviation';
    }
    else if (typeId === ResourceType.COMMENT) {
        recipientType = 'comments';
    }
    return recipientType;
}
//# sourceMappingURL=utils.js.map